import { useCallback, useEffect, useState } from "react";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import useAuth from "../../routes/login/AuthContext";

import Api from "../../services/Api";

interface IBlockedWord {
  id: number;
  pattern: string;
  l1Id: number;
  comment: string | null;
}

export const useBlockedWords = () => {
  const { getAuthToken } = useAuth();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const [isLoading, setIsLoading] = useState(false);
  const [blockedWords, setBlockedWords] = useState<IBlockedWord[]>([]);

  const getBlockedWords = useCallback(async () => {
    setIsLoading(true);

    const res = await Api.getProfanityList(selectedNetworkId, await getAuthToken());

    if (res.result) {
      setBlockedWords(res.result.profanityFilterBadWords);
    }

    setIsLoading(false);
  }, [selectedNetworkId]);

  useEffect(() => {
    getBlockedWords();
  }, [selectedNetworkId]);

  return {
    isLoading,
    blockedWords,
    getBlockedWords,
  };
};
